import { motion } from "framer-motion";
import { ArrowDown } from "lucide-react";
import EggSpotlight from "@/components/EggSpotlight";
import { scrollToContact } from "@/lib/scroll";
import { REVEAL_DELAY } from "@/lib/intro";

const line = {
  hidden: { y: "115%" },
  show: (i) => ({
    y: "0%",
    transition: { duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: REVEAL_DELAY + 0.15 + i * 0.13 },
  }),
};

const MaskedLine = ({ index, children }) => (
  <span className="block overflow-hidden pb-1">
    <motion.span className="block" custom={index} variants={line} initial="hidden" animate="show">
      {children}
    </motion.span>
  </span>
);

const Hero = () => (
  <section className="relative mx-auto grid max-w-6xl items-center gap-10 px-5 pb-16 pt-28 sm:pt-32 lg:grid-cols-[1.15fr_0.85fr] lg:pb-24">
    <div>
      <motion.p
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.1 }}
        className="mb-5 inline-flex items-center gap-2 rounded-full border border-[#E5D1A6] bg-[#FAF3E6] px-4 py-1.5 font-mono-brand text-[10px] font-semibold uppercase tracking-[0.22em] text-[#6B1D2F]"
      >
        <span className="h-1.5 w-1.5 rounded-full bg-[#C5A059]" />
        KSR Poultry Farms — Vikarabad, Telangana
      </motion.p>

      <h1
        data-testid="hero-headline"
        className="font-display text-4xl font-bold leading-[1.08] tracking-tight text-[#2A1810] sm:text-5xl lg:text-6xl"
      >
        <MaskedLine index={0}>Fresh white eggs,</MaskedLine>
        <MaskedLine index={1}>
          sold <em className="font-display italic text-[#6B1D2F]">wholesale</em>,
        </MaskedLine>
        <MaskedLine index={2}>
          by the <span className="text-[#C5A059]">tray.</span>
        </MaskedLine>
      </h1>

      <motion.p
        data-testid="hero-subtext"
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: REVEAL_DELAY + 0.65 }}
        className="mt-6 max-w-md text-base leading-relaxed text-[#5C4A42] sm:text-lg"
      >
        Wholesale eggs supplier in Mansampalle, Vikarabad. Farm-fresh white eggs
        in trays — rates change daily, so message us for today's price or any
        other enquiry.
      </motion.p>

      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: REVEAL_DELAY + 0.8 }}
        className="mt-8 flex flex-col gap-3 sm:flex-row"
      >
        <motion.button
          type="button"
          data-testid="hero-contact-button"
          onClick={scrollToContact}
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.97 }}
          className="flex items-center justify-center gap-2.5 rounded-full bg-[#6B1D2F] px-7 py-4 text-base font-semibold text-[#FAF3E6] shadow-[0_14px_30px_rgba(107,29,47,0.28)] transition-colors duration-300 hover:bg-[#521422]"
        >
          Get today's rate
          <ArrowDown size={18} strokeWidth={2.2} />
        </motion.button>
      </motion.div>
    </div>

    <EggSpotlight />
  </section>
);

export default Hero;
